import { createFileRoute } from "@tanstack/react-router";
import AdminResourceDetailPage from "@/pages/admin/lms/resources/detail";
import { useLmsPermissions } from "@/pages/admin/lms";

export const Route = createFileRoute("/app/admin/lms/resources/$resourceId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { resourceId } = Route.useParams();
  const {
    userCanAssociateMaterialsAndCriteria,
    userCanAssociateMaterialsAndTags,
    userCanAssociateMaterialsAndUserFunctions,
    userCanEditAllMaterials,
    userCanViewAllCriteria,
    userCanViewAllMaterials,
    userCanViewAllSettingTags,
    userCanViewAllTags,
  } = useLmsPermissions();

  return (
    <AdminResourceDetailPage
      id={Number(resourceId)}
      userCanAssociateMaterialsAndCriteria={userCanAssociateMaterialsAndCriteria}
      userCanAssociateMaterialsAndTags={userCanAssociateMaterialsAndTags}
      userCanAssociateMaterialsAndUserFunctions={userCanAssociateMaterialsAndUserFunctions}
      userCanEditAllMaterials={userCanEditAllMaterials}
      userCanViewAllCriteria={userCanViewAllCriteria}
      userCanViewAllMaterials={userCanViewAllMaterials}
      userCanViewAllSettingTags={userCanViewAllSettingTags}
      userCanViewAllTags={userCanViewAllTags}
    />
  );
}
